import useTabs from '@/hooks/useTabs'
import { tabs } from './tab'
import { Tabs, Typogaphy } from 'vnetwork-ui'
import useAuthStore from '@/stores/useAuthStore'
import { useTranslation } from 'react-i18next'
import InformationIcon from '@/icons/InformationIcon'
import ContractPendingIcons from '@/icons/ContractPendingIcons'
import SecurityIcons from '@/icons/SecurityIcons'
import ContractIcons from '@/icons/ContractIcons'
import ContractOverviewIcons from '@/icons/ContractOverviewIcons'
import VCardDetail from './VCardDetail'
import { getEmployeeTypeLabel, getSeniority } from '../constants'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'
import { ScrollText, Megaphone } from 'lucide-react'

const Home = () => {
    const { TabComponent, TabProps } = useTabs({ tabs })
    const { employee } = useAuthStore()
    const { t } = useTranslation()
    const navigate = useNavigate()
    return (
        <div className="grid lg:grid-cols-6 gap-2">
            <div className="lg:col-span-2 col-span-4 mt-2">
                <div className="rounded-lg bg-white shadow-sm">
                    <VCardDetail />
                </div>

                <div className="p-4 bg-white rounded-lg mt-2">
                    <div className="flex items-center gap-2 mb-4">
                        <ContractOverviewIcons className="w-6 h-6" />
                        <Typogaphy size="small" className="font-medium">
                            {t('account-infomation')}
                        </Typogaphy>
                    </div>

                    <div className="grid grid-cols-2 gap-y-3">
                        <Typogaphy size="small" className="text-black">
                            {t('account-part')}
                        </Typogaphy>
                        <Typogaphy size="small" className="font-medium">
                            {employee?.department_name || '-'}
                        </Typogaphy>

                        <Typogaphy size="small" className="text-black">
                            {t('employee_code')}
                        </Typogaphy>
                        <Typogaphy
                            size="small"
                            className="font-medium break-all"
                        >
                            {employee?.employee_code || '-'}
                        </Typogaphy>

                        <Typogaphy size="small" className="text-black">
                            {t('account-form')}
                        </Typogaphy>
                        <Typogaphy size="small" className="font-medium">
                            {getEmployeeTypeLabel(
                                t,
                                employee?.employee_contract_type
                            ) || '-'}
                        </Typogaphy>
                        <Typogaphy size="small" className="text-black">
                            {t('account-onboard')}
                        </Typogaphy>
                        <Typogaphy size="small" className="font-medium">
                            {dayjs(employee?.employee_start_date).format(
                                'DD/MM/YYYY'
                            ) || '-'}
                        </Typogaphy>
                        <Typogaphy size="small" className="text-black">
                            {t('account-seniority')}
                        </Typogaphy>
                        <Typogaphy size="small" className="font-medium">
                            {getSeniority(employee?.employee_start_date, t) ||
                                '-'}
                        </Typogaphy>
                    </div>
                </div>

                <button
                    type="button"
                    onClick={() => navigate('/account/referral')}
                    className="w-full mt-2 bg-white rounded-lg p-4 cursor-pointer hover:shadow-md transition-shadow text-left"
                >
                    <div className="flex items-center gap-2">
                        <Megaphone className="w-6 h-6 text-primary" />
                        <Typogaphy size="small" className="font-medium">
                            {t('affiliate:referral', 'Referral')}
                        </Typogaphy>
                    </div>
                </button>

                <div className="grid grid-cols-2 rounded-lg mt-2 gap-2">
                    <button
                        type="button"
                        className="bg-white rounded-lg p-4 cursor-pointer hover:shadow-md transition-shadow text-left"
                        onClick={() => navigate('/account/info')}
                    >
                        <div className="flex items-center gap-2">
                            <InformationIcon className="text-[#9467BD]" />
                            <Typogaphy size="small" className="font-medium">
                                {t('detailed-information')}
                            </Typogaphy>
                        </div>
                    </button>
                    <button
                        type="button"
                        className="bg-white rounded-lg p-4 cursor-pointer hover:shadow-md transition-shadow text-left"
                        onClick={() => navigate('/account/contracts')}
                    >
                        <div className="flex items-center gap-2">
                            <ContractIcons className="w-6 h-6 text-red-400" />
                            <Typogaphy size="small" className="font-medium">
                                {t('contracts')}
                            </Typogaphy>
                        </div>
                    </button>
                    <button
                        type="button"
                        className="bg-white rounded-lg p-4 cursor-pointer hover:shadow-md transition-shadow text-left"
                        onClick={() => navigate('/account/working-process')}
                    >
                        <div className="flex items-center gap-2">
                            <ContractPendingIcons className="w-6 h-6 text-orange-400" />
                            <Typogaphy size="small" className="font-medium">
                                {t('account-working-process')}
                            </Typogaphy>
                        </div>
                    </button>
                    <button
                        type="button"
                        className="bg-white rounded-lg p-4 cursor-pointer hover:shadow-md transition-shadow text-left"
                        onClick={() => navigate('/account/password-security')}
                    >
                        <div className="flex items-center gap-2">
                            <SecurityIcons className="text-primary" />
                            <Typogaphy size="small" className="font-medium">
                                {t('account-passwork-security')}
                            </Typogaphy>
                        </div>
                    </button>
                    <button
                        type="button"
                        className="bg-white rounded-lg p-4 cursor-pointer hover:shadow-md transition-shadow text-left"
                        onClick={() => navigate('/account/regulations')}
                    >
                        <div className="flex items-center gap-2">
                            <ScrollText className="w-6 h-6 text-emerald-500" />
                            <Typogaphy size="small" className="font-medium">
                                {t(
                                    'regulations:accepted-regulations',
                                    'Accepted Policies'
                                )}
                            </Typogaphy>
                        </div>
                    </button>
                </div>
            </div>

            <div className="col-span-4">
                <Tabs {...TabProps} className="w-full" />

                <div className="mt-2">{TabComponent}</div>
            </div>
        </div>
    )
}
export default Home
